<template>
    <div class="row">
      <div class="col-md-12">
        <gestiune-transfer-form :route="route" @on-submit="onPageSubmit"></gestiune-transfer-form>
      </div>
    </div>
</template>
  <script>
    import Vue from 'vue'
    import {Select, Option} from 'element-ui'
    import GestiuneTransferForm from './ManagementTransferForm.vue'
    Vue.use(Select)
    export default {
      components: {
        [Select.name]: Select,
        [Option.name]: Option,
        GestiuneTransferForm
      },
      props: {
        route: {
          type: Object,
          default: () => ({})
        }
      },
      data () {
        return {
          pageModel: {},
          page: {},
          modelValidations: {
            required: {
              required: true
            }
          }
        }
      },
      methods: {
        onPageSubmit (model, isValid) {
          this.pageModel = model
        }
      }
    }
  </script>
  <style scoped>
  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Transfer/ManagementTransferAdd.vue